import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout";
import { Home } from "@/pages/home";
import { BookList } from "@/pages/book-list";
import { Book } from "@/pages/book";
import { AuthorList } from "@/pages/author-list";
import { Author } from "@/pages/author";
import { PeopleList } from "@/pages/people-list";
import { Person } from "@/pages/person";
import { Category } from "@/pages/category";

export function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="books">
            <Route index element={<BookList />} />
            <Route path=":slug" element={<Book />} />
          </Route>
          <Route path="authors">
            <Route index element={<AuthorList />} />
            <Route path=":slug" element={<Author />} />
          </Route>
          <Route path="people">
            <Route index element={<PeopleList />} />
            <Route path=":slug" element={<Person />} />
          </Route>
          <Route path="categories/:slug" element={<Category />} />
        </Route>
      </Routes>
    </Router>
  );
}